import { useState } from "react";

export function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSsoLogin = () => {
    window.location.href = "/sso/login";
  };

  async function handleAdminLogin(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const response = await fetch("/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        setError(body.error || "Sign in failed");
        return;
      }
      window.location.href = "/";
    } catch {
      setError("Sign in failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-5 text-white">
      <div className="w-full max-w-[448px]">
        <div className="mb-7 flex flex-col items-center gap-3">
          <img className="h-14 w-14 rounded-xl" src="/static/favicon.svg" alt="Argus Trace" />
          <h1 className="m-0 max-w-[360px] text-center text-2xl font-semibold leading-tight text-zinc-100">Sign in to Argus Trace</h1>
        </div>

        <form className="flex flex-col gap-3" onSubmit={handleAdminLogin}>
          <label className="flex flex-col gap-1 text-sm font-semibold text-zinc-100">
            Username
            <input
              value={username}
              onChange={event => setUsername(event.target.value)}
              autoComplete="username"
              className="border-0 border-b border-zinc-800 bg-transparent px-0 py-2 text-sm font-normal text-zinc-100 outline-none transition-colors placeholder:text-zinc-600 focus:border-teal"
              placeholder="Enter your username"
            />
          </label>
          <label className="flex flex-col gap-1 text-sm font-semibold text-zinc-100">
            Password
            <input
              type="password"
              value={password}
              onChange={event => setPassword(event.target.value)}
              autoComplete="current-password"
              className="border-0 border-b border-zinc-800 bg-transparent px-0 py-2 text-sm font-normal text-zinc-100 outline-none transition-colors placeholder:text-zinc-600 focus:border-teal"
              placeholder="Enter your password"
            />
          </label>
          {error && <div className="text-xs text-red" role="alert">{error}</div>}
          <button
            type="submit"
            disabled={submitting}
            className="mt-3 h-10 rounded-full border border-zinc-900 bg-zinc-950 px-4 text-sm font-semibold text-zinc-100 transition-colors hover:bg-zinc-900 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <div className="mt-5 text-center text-sm text-zinc-100">
          <span>Don't have an account? </span>
          <button type="button" onClick={handleSsoLogin} className="bg-transparent p-0 text-sm font-semibold text-zinc-100 underline underline-offset-2">
            Sign up
          </button>
        </div>

        <div className="my-3 flex items-center gap-3 text-sm font-semibold text-zinc-100" aria-label="or sign in with SSO">
          <div className="h-px flex-1 bg-zinc-800" />
          <span>or</span>
          <div className="h-px flex-1 bg-zinc-800" />
        </div>

        <button
          type="button"
          onClick={handleSsoLogin}
          className="flex h-11 w-full items-center justify-center gap-3 rounded-full border border-zinc-900 bg-zinc-950 px-4 text-sm font-semibold text-zinc-100 transition-colors hover:bg-zinc-900"
        >
          <MicrosoftIcon />
          Continue with Microsoft SSO
        </button>
      </div>
    </div>
  );
}


function MicrosoftIcon() {
  return (
    <span className="grid h-5 w-5 grid-cols-2 grid-rows-2 gap-0.5" aria-label="Microsoft" role="img">
      <span className="bg-[#f25022]" />
      <span className="bg-[#7fba00]" />
      <span className="bg-[#00a4ef]" />
      <span className="bg-[#ffb900]" />
    </span>
  );
}
